export const selectUserDetails = ({ user }) => user;
